import { FileText, Info } from 'lucide-react';

import { ResultsPanel } from '../components/ResultsPanel';

/**
 * AI Team · Results — the cross-agent results archive. Reached from the AI Team
 * sub-nav. Mine / Shared / (All, for founders) scope tabs live inside the
 * panel; scoping is enforced server-side by role.
 */
export function AiTeamResultsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <FileText className="size-6" /> Results
        </h1>
        <p className="text-muted-foreground text-sm">
          Outputs your AI team has produced across every agent.
        </p>
      </div>

      <div className="bg-muted/30 text-muted-foreground flex items-start gap-2 rounded-md border p-3 text-sm">
        <Info className="mt-0.5 size-4 shrink-0" />
        <p>
          <strong>Your results:</strong> you see the outputs you&apos;ve saved plus anything a
          teammate has shared. Open a result to read, copy, download, or share it.
        </p>
      </div>

      <ResultsPanel />
    </div>
  );
}
